export function deepClone(instance) {
    try {
        if (instance === null)
            return null;
        if (instance === undefined)
            return undefined;
        let primitives = ["string", "boolean", "symbol", "number", "bigint"];
        if (primitives.includes(typeof instance))
            return instance;
        let copy;
        if (instance instanceof Array) {
            copy = [...instance];
            for (let i = 0; i < copy.length; i++) {
                copy[i] = deepClone(copy[i]);
            }
            return copy;
        }
        else {
            let prot = Object.getPrototypeOf(instance);
            try {
                copy = Object.create(prot);
            }
            catch (err) {
                throw new Error(`Can't create instance of ${prot.name}. 
        Class "${instance.constructor.name}" should have a default parameterless constructor or parameters in the constructor should be optional.`);
            }
            Object.assign(copy, instance);
            Object.getOwnPropertyNames(copy).forEach(name => {
                if (typeof copy[name] == 'object' && copy[name] !== null) {
                    copy[name] = deepClone(copy[name]);
                }
            });
            return copy;
        }
    }
    catch (ex) {
        throw Error("Can't clone subject: " + instance.constructor.name + "; Reason: " + ex.message);
    }
}
